import { all } from 'redux-saga/effects';
import { arrowModelSaga } from './arrowModelSaga';
import { cartSaga } from './cart';
import { designSaga } from './designSaga';
import { recommendDesignSaga } from './fetchRecommendDesignSaga';
import { priceSumSaga } from './priceSumSaga';
import { fetchArrowProductSaga } from './fetchArrowProductSaga';
import { orderPartsHelpFetchSaga } from './orderPartsHelp/fetch';
import { fetchInitProductSetSaga } from './fetchInitProductSetSaga';

function* rootSaga(): Generator<any, any, any> {
    console.log('[saga] start root saga');

    yield all([
        ...arrowModelSaga,
        ...cartSaga,
        ...designSaga,
        ...recommendDesignSaga,
        ...priceSumSaga,
        ...fetchArrowProductSaga,
        ...orderPartsHelpFetchSaga,
        ...fetchInitProductSetSaga,
    ]);
}

export default rootSaga;
